import {DATEPICKER_SELECT_CURRENT_REQUEST} from "../../../enums/Request/currentRequestControls.types";

export const datepickerSelectCurrentRequest = ({date, index, field}) => {
    return {
        type: DATEPICKER_SELECT_CURRENT_REQUEST,
        payload: {date, index, field},
    };
};
